/**
 * Service
 * @name app.core.LoggerService
 *
 * This is logger service, responsible for logging the messages.
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public _loading = false;
  loadingStatus: Subject<any> = new Subject();

  /**
   * Gets loading
   *
   * It is used to get loader value.
   */
  get loading(): boolean {
    return this._loading;
  }

  /**
   * Sets loading
   *
   * It is used for set loading value
   */
  set loading(value) {
    this._loading = value;
    this.loadingStatus.next(value);
  }

  /**
   * Start loading
   *
   * It is used for start loading
   */
  startLoading() {
    this.loading = true;
  }

  /**
   * Stops loading
   *
   * It is used for stop loading
   */
  stopLoading() {
    this.loading = false;
  }
}
